// PDP variant name display + additional-media visibility swap.
// Was inline in sections/main-product.liquid; extracted so the JS is
// cacheable across PDPs and not re-shipped as HTML on every request.

document.addEventListener('DOMContentLoaded', function () {
  const selectedVariant = document.getElementById('selected_variant');
  const variantSwitcher = document.querySelector('variant-radios .product-form__input-colors');
  if (!variantSwitcher) return;

  const variantSwitcherInputs = variantSwitcher.querySelectorAll('input[type="radio"]');

  function updateSelectedVariant(input) {
    if (!input.checked) return;

    const labelForThisInput = variantSwitcher.querySelector(`label[for="${input.id}"]`);
    const variantName = labelForThisInput?.getAttribute('data-variant-name');
    if (selectedVariant) selectedVariant.textContent = variantName || '';

    // Hide all additional-media thumbnails, then show the ones for the selected variant
    document.querySelectorAll('.thumbnail-list_item--variant--additional-media').forEach((img) => {
      img.style.display = 'none';
    });
    const variantId = input.getAttribute('data-variant-id');
    document
      .querySelectorAll(`.thumbnail-list_item--variant--additional-media[data-variant-id="${variantId}"]`)
      .forEach((img) => {
        img.style.display = 'block';
      });
  }

  // If URL has ?variant=<id>, prefer that; otherwise use whichever input is checked
  const variantId = new URL(window.location.href).searchParams.get('variant');
  const inputWithVariantId = variantId
    ? variantSwitcher.querySelector(`input[data-variant-id="${variantId}"]`)
    : null;

  if (inputWithVariantId) {
    updateSelectedVariant(inputWithVariantId);
  } else {
    variantSwitcherInputs.forEach((input) => {
      if (input.checked) updateSelectedVariant(input);
    });
  }

  variantSwitcherInputs.forEach((input) => {
    input.addEventListener('change', () => updateSelectedVariant(input));
  });
});
